import axios from "axios";

export interface IBackInStockNotificationData
{
	email: string;
	productID: string;
	sizeList: string;
	skuList: string;
}

export class BackInStockReminderService
{
	public AddReminder = (data: IBackInStockNotificationData): Promise<any> =>
	{
		return axios.post("/services/client.asmx/AddOutOfStockReminder", data)
			.catch((error) =>
			{
				console.log(error);
			});
	};
}